import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Box, Typography, Container, TextField, Button, FormControlLabel, Checkbox } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from './api';
import Header from './components/Header';
import { useConfirmBackLogout } from './common/useConfirmBackLogout';
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";

const CreateMail = () => {
  const [eventDate, setEventDate] = useState(''); // datetime文字列
  const [mailTitle, setMailTitle] = useState('');
  const [mailBody, setMailBody] = useState('');
  const [bulkMailTitle, setBulkMailTitle] = useState('');
  const [bulkMailBody, setBulkMailBody] = useState('');
  const [exhibitors, setExhibitors] = useState([]);
  const [history, setHistory] = useState([]);
   const [showFormMenu, setShowFormMenu] = useState(false);
  // const [selectedEmails, setSelectedEmails] = useState([]);
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('user');
    sessionStorage.clear(); // ← これ追加！
    navigate('/login/host');
  };

  useEffect(() => {
    api.get('/api/exhibitors/unsubmitted')
      .then(res => setExhibitors(res.data))
      .catch(err => console.error('未提出出展者の取得失敗:', err));
  }, []);

  useEffect(() => {
    api.get('/api/mail-history')
      .then(res => setHistory(res.data))
      .catch(err => console.error('履歴取得失敗:', err));
  }, []);

  const handleSaveSettings = async () => {
    try {
      await api.put('/api/mail-settings/update', {
        event_date: eventDate, // YYYY-MM-DDTHH:MM形式
        mail_subject: mailTitle,
        mail_body: mailBody,
      });
      alert('設定を保存しました');
    } catch (err) {
      console.error('保存失敗:', err);
      alert('保存に失敗しました');
    }
  };

  useEffect(() => {
    api.get('/api/mail-settings/get')
      .then((res) => {
        const { event_date, mail_subject, mail_body } = res.data;
        setEventDate(event_date ?? '');
        setMailTitle(mail_subject ?? '');
        setMailBody(mail_body ?? '');
      })
      .catch(err => {
        console.error('メール設定取得失敗:', err);
      });
  }, []);

  // 一斉送信
  const handleBulkSend = async () => {
    if (!bulkMailTitle || !bulkMailBody) {
      alert("件名と本文を入力してください");
      return;
    }

    const ok = window.confirm(
      "未提出・再提出の出展者全員に催促メールを送信します。\n本当に送信しますか？"
    );
    if (!ok) return;

    try {
      const res = await api.post("/api/mail/send-remind", {
        mail_subject: bulkMailTitle,
        mail_body: bulkMailBody,
      });

      alert(res.data.message || "催促メール送信ジョブを登録しました");
    } catch (err) {
      console.error(err);
      alert("送信に失敗しました");
    }
  };

  // テストメール送信機能
  const handleRemindTestSend = async () => {
    if (!bulkMailTitle || !bulkMailBody) {
      alert("件名と本文を入力してください");
      return;
    }

    const ok = window.confirm(
      "テストメールを送信します。\n送信先は固定のメールアドレスです。"
    );
    if (!ok) return;

    try {
      const res = await api.post("/api/mail/send-to-unsubmitted-test", {
        mail_subject: bulkMailTitle,
        mail_body: bulkMailBody,
      });
      console.log(res.data)

      alert("テストメールを送信しました");
    } catch (err) {
      console.error(err);
      alert("テスト送信に失敗しました");
    }
  };

  const handleDownloadLatestLog = async () => {
    try {
      const res = await api.get(
        "/api/mail/latest-log",
        {
          params: {job_type: "remind"},
          responseType: "blob" // ★ ここ超重要
        }
      );

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "催促メール_最新メール送信ログ.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);
      alert("最新送信ログのダウンロードに失敗しました");
    }
  };

  const aggregatedHistory = history.reduce((acc, row) => {
    const utcDate = new Date(row.sent_at);
    const jstDate = new Date(utcDate.getTime() + 9 * 60 * 60 * 1000);

    // 秒までに丸める
    const dateStr = jstDate.getFullYear() + "/" +
                    String(jstDate.getMonth() + 1).padStart(2, "0") + "/" +
                    String(jstDate.getDate()).padStart(2, "0") + " " +
                    String(jstDate.getHours()).padStart(2, "0") + ":" +
                    String(jstDate.getMinutes()).padStart(2, "0") + ":" +
                    String(jstDate.getSeconds()).padStart(2, "0");

    const existing = acc.find(item => item.dateStr === dateStr);
    if (existing) {
        existing.recipientsCount += row.recipients.length;
    } else {
        acc.push({ dateStr, recipientsCount: row.recipients.length });
    }
    return acc;
  }, []);

  useConfirmBackLogout(navigate);
  useNavigationHistory();

  return (
    <div>
          <Header
            title="しんきんビジネスマッチング　ビジネスフェア2026 メール作成"
          />
          <Container sx={{ mt: 5 }}>
            <Box sx={{ display: 'flex' }}>
              {/* 左メニュー */}
              <Box sx={{ width: '20%', pr: 2, borderRight: '1px solid #ccc' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Box className="menu-item" onClick={() => navigate('/host-dashboard')}>
                    申請状況
                  </Box>
                  <Box
                    className="menu-group"
                    id="hover-block"
                    onMouseEnter={() => {}}
                    onMouseLeave={() => {}}
                  >
                    <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                      会社情報
                    </Box>
                      {showFormMenu && (
                        <Box className="hover-menu">
                          <Typography
                            sx={{ color: '#0071bc', textAlign: 'center' }}
                            className='form-button'
                            onClick={() => navigate('/exhibitor-info')}
                          >
                            出展者
                          </Typography>
                          <Typography
                            sx={{ color: '#0071bc', textAlign: 'center' }}
                            className='form-button'
                            onClick={() => navigate('/corporate-info')}
                          >
                            協力会社
                          </Typography>
                        </Box>
                      )}
                  </Box>
                  <Box className="menu-item" onClick={() => navigate('/create-mail')}>
                    メール作成
                  </Box>
                  <Box className="menu-item" onClick={() => navigate('/create-notice')}>
                    お知らせ作成
                  </Box>
                  <Box className="menu-item" onClick={() => navigate('/form-history')}>
                    再提出ログ確認
                  </Box>
                </Box>
                <BackButton />
              </Box>
    
                {/* メインコンテンツ（右） */}
                <Box sx={{ width: '80%', pl: 2 }}>
                  <Box sx={{ pb: 3 }}>
                    <Typography variant="h6" className="title" gutterBottom sx={{ mb: 2 }}>
                      催促メール任意送信
                    </Typography>

                    <Typography gutterBottom sx={{ mb: 2, color: "red" }}>
                      「未提出・再提出」のステータスを持つ申請書が一つでもある出展者向けに送る「催促」メールです。
                      全出展者、または任意の出展者に向けたメールを作成する場合は
                      <span
                        onClick={() => navigate("/exhibitor-info")}
                        style={{ color: "blue", cursor: "pointer" }}
                      >
                        こちら
                      </span>
                      からお願いします。
                    </Typography>

                    <TextField
                      label="件名"
                      fullWidth
                      value={bulkMailTitle}
                      onChange={(e) => setBulkMailTitle(e.target.value)}
                      sx={{ my: 2 }}
                    />

                    <TextField
                      label="本文"
                      multiline
                      rows={6}
                      fullWidth
                      value={bulkMailBody}
                      onChange={(e) => setBulkMailBody(e.target.value)}
                      sx={{ mb: 3 }}
                    />

                    <Box display="flex" gap={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleBulkSend}
                      >
                        一斉送信
                      </Button>

                      <Button
                        variant="outlined"
                        color='warning'
                        onClick={handleRemindTestSend}
                      >
                        テストメール送信
                      </Button>
                    </Box>
                    <Box py={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownloadLatestLog}
                      >
                        最新送信ログをダウンロード
                      </Button>
                    </Box>
                  </Box>
                  <Typography variant="h6" className='title' gutterBottom>催促メール予約送信</Typography>
                  <TextField
                      label="送信日"
                      type="datetime-local"
                      fullWidth
                      value={eventDate}
                      onChange={(e) => setEventDate(e.target.value)}
                      sx={{ my: 2 }}
                      InputLabelProps={{ shrink: true }}
                  />

                  <TextField
                    label="件名"
                    fullWidth
                    value={mailTitle}
                    onChange={(e) => setMailTitle(e.target.value)}
                    sx={{ mb: 2 }}
                  />

                  <TextField
                    label="本文"
                    multiline
                    rows={6}
                    fullWidth
                    value={mailBody}
                    onChange={(e) => setMailBody(e.target.value)}
                    sx={{ mb: 2 }}
                  />

                  {/* <Typography variant="h6" gutterBottom>送信対象の出展者</Typography>
                  <Box sx={{ mb: 2 }}>
                    {exhibitors.map((ex, index) => (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            checked={selectedEmails.includes(ex.email)}
                            onChange={() => handleCheckboxChange(ex.email)}
                          />
                        }
                        label={`${ex.company_name} <${ex.email}>`}
                      />
                    ))}
                  </Box> */}
                  <Button
                    variant="outlined"
                    sx={{ mt: 2, ml: 2 }}
                    onClick={handleSaveSettings}
                  >
                    設定を保存
                  </Button>
                  {/* <Button variant="contained" onClick={handleSend}>一斉送信</Button> */}
                  <Box sx={{ mt: 6 }}>
                    <Typography variant="h6" gutterBottom>送信履歴</Typography>
                    <TableContainer component={Box}>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>送信日時</TableCell>
                            <TableCell>対象数</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {aggregatedHistory.map((row, index) => (
                              <TableRow key={index}>
                              <TableCell>{row.dateStr}</TableCell>
                              <TableCell>{row.recipientsCount}</TableCell>
                              </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
            </Box>
          </Container>
          <footer>
            <Typography>
              © 2026 THE MID-JAPAN ECONOMIST.
            </Typography>
          </footer>
        </div>
  );
};

export default CreateMail;
